import React from "react";
import styled from "styled-components";
import { RoundedBlock } from "./roundedBlock";

interface TitledBlockProps extends React.HTMLAttributes<HTMLDivElement> {
	title: string;
}
export const TitledBlock: React.FC<TitledBlockProps> = ({ title, children, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<BlockTitle>{title}</BlockTitle>
			{children}
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	padding: 34px 50px;

	@media (max-width: 900px) {
		padding: 30px 15px;
	}
`;

const BlockTitle = styled.div`
	${({ theme }) => theme.textStyles.title};
	margin-bottom: 40px;
	@media (max-width: 900px) {
		margin-bottom: 30px;
	}
`;
